// Copyright (C) 2024 Eaglescience Software B.V.

import { PlacementInformation } from '@src/app/model/placement-information';
import { Id, ModulePlacement } from '@ess/jg-rule-executor';

export class PlacementInfoMap {
  id: Id<ModulePlacement>;
  markers: PlacementInformation[];

  constructor(id: Id<ModulePlacement>, markers: PlacementInformation[]) {
    this.id = id;
    this.markers = markers;
  }
}
